import React from 'react';
import { ExternalLink } from 'lucide-react';

export const getYouTubeId = (url) => {
  try {
    const parsed = new URL(url);
    const host = parsed.hostname.replace(/^www\./, '');
    const id = host === 'youtu.be' ? parsed.pathname.slice(1)
      : ['youtube.com', 'm.youtube.com', 'youtube-nocookie.com'].includes(host)
        ? parsed.searchParams.get('v') || parsed.pathname.split('/')[2] : null;
    return /^[\w-]{11}$/.test(id || '') ? id : null;
  } catch {
    return null;
  }
};

export const TrailerPlayer = ({ trailerUrl, title, testId }) => {
  const videoId = getYouTubeId(trailerUrl);
  if (!videoId) return null;
  const params = new URLSearchParams({ autoplay: '1', mute: '1', rel: '0',
    playsinline: '1', origin: window.location.origin });

  return (
    <div className="w-full bg-black" data-testid={`${testId}-player`}>
      <div className="relative w-full aspect-video max-h-[70vh]">
        <iframe
          src={`https://www.youtube.com/embed/${videoId}?${params}`}
          title={`${title} Trailer`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          data-testid={testId}
          className="absolute inset-0 w-full h-full"
        />
      </div>
      <div className="flex justify-end px-3 py-2 border-t border-white/10">
        <a
          href={`https://www.youtube.com/watch?v=${videoId}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`${testId}-youtube-link`}
          className="inline-flex items-center gap-2 text-sm text-gray-300 hover:text-white transition-colors"
          aria-label={`Watch ${title} trailer on YouTube`}
        >
          Watch on YouTube <ExternalLink className="w-4 h-4" />
        </a>
      </div>
    </div>
  );
};